export default __webpack_public_path__ + "static/ShiseidoGinza-Bold-94837af44096820c50742d5d24631946.woff";